// extracted by mini-css-extract-plugin
export default {"versionHistoryList":"DQ02lgDEY8WPBHoC4GY2"};